import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Franklin Fernandez | Full Stack Developer & Graphic Designer",
  description = "17+ years of experience in UI/UX, PHP, Laravel, and graphic design",
  keywords = "full stack developer, graphic designer, UI/UX, PHP, Laravel",
  image = "/assets/img/profile-image.webp", // Make sure this path is correct from the public folder root
  url = typeof window !== 'undefined' ? window.location.href : '',
  type = "website"
}) => {
  // Logging is fine for testing
  useEffect(() => {
    console.log('SEO Component rendered with title:', title);
  }, [title]);

  // --- RECOMMENDED ADDITIONS ---
  // Construct absolute URL for images for OG/Twitter tags
  const absoluteImageUrl = typeof window !== 'undefined'
    ? `${window.location.origin}${image.startsWith('/') ? image : '/' + image}` // Ensure leading slash
    : image; // Fallback for SSR or build time

  // Determine the canonical URL
  const canonicalUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  // --- END RECOMMENDED ADDITIONS ---


  return (
    // Ensure no defer={false} here
    <Helmet>
      {/* Standard metadata */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Franklin Fernandez" />
      {/* Add canonical link */}
      <link rel="canonical" href={canonicalUrl} />

      {/* OpenGraph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} /> {/* Use canonical URL */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absoluteImageUrl} /> {/* Use absolute URL */}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content="@frankdesigns5" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteImageUrl} /> {/* Use absolute URL */}
    </Helmet>
  );
};

export default SEO;